export default __webpack_public_path__ + "static/media/Icon=Billing.b478406f.svg";